import React, { useEffect, useRef, useState } from "react";
import Popper from "@mui/material/Popper";
import { useLocation } from "react-router-dom";
import { ProductDropdown } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/styles/local/TaskProductsPartsPopup.css";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";

const TaskProductsPartsPopup = ({
  taskId,
  onSelectParts,
  onClose,
  parentSelectedParts,
  currentPartId,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");

  const { fetchProductDropdown } = useSelector((state) => state.user);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [showBox, setShowBox] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);

  useEffect(() => {
    const currentParts = (parentSelectedParts || []).filter(
      (item) =>
        item.productPartName &&
        !String(item.productPartid || "").startsWith("task-"),
    );

    setSelectedParts(currentParts);
  }, [parentSelectedParts, currentPartId]);

  useEffect(() => {
    dispatch(ProductDropdown());
  }, []);

  useEffect(() => {
    if (fetchProductDropdown?.status === true) {
      setShowLoader(false);
      setProductList(fetchProductDropdown?.data);
    }
  }, [fetchProductDropdown]);

  console.log("asc443", selectedParts);

  return (
    <div className="task-parts-main">
      <div className="task-parts-header">
        <p className="task-parts">Parts</p>
        <input
          type="text"
          className="task-parts-search"
          value={searchValue}
          placeholder="Search"
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
        />
        <img
          src={DelIcon}
          alt=""
          className="pointer"
          onClick={(e) => {
            onClose();
          }}
        />
      </div>

      {/* data list */}
      <div className="task-parts-list">
        <p>{showLoader && "Please wait..."}</p>

        {productList
          ?.filter((x) =>
            x.productPartName
              ?.toLowerCase()
              .includes(searchValue.toLowerCase()),
          )
          ?.map((item, index) => {
            const isChecked = selectedParts.some(
              (x) => x.productPartid === item.productPartid,
            );
            return (
              <div className="task-parts-list-item" key={item.productPartid}>
                <label
                  className="task-parts-list-item-label"
                  id="task-input-checkbox"
                >
                  <input
                    type="checkbox"
                    className="pointer"
                    style={{ width: "16px", height: "16px" }}
                    checked={selectedParts.some(
                      (x) => x.productPartid === item.productPartid,
                    )}
                    readOnly={selectedParts.some(
                      (x) =>
                        x.productPartid === item.productPartid &&
                        x.taskProductPartid,
                    )}
                    onChange={(e) => {
                      const isSaved = selectedParts.some(
                        (x) =>
                          x.productPartid === item.productPartid &&
                          x.taskProductPartid,
                      );

                      // API se saved product ko uncheck mat hone do
                      if (isSaved) return;

                      const checked = e.target.checked;

                      const updatedParts = checked
                        ? selectedParts.some(
                            (x) => x.productPartid === item.productPartid,
                          )
                          ? selectedParts
                          : [...selectedParts, item]
                        : selectedParts.filter(
                            (x) => x.productPartid !== item.productPartid,
                          );

                      setSelectedParts(updatedParts);
                      // onSelectParts(updatedParts);
                    }}
                  />
                  <p className="mb-0">{item.productPartName}</p>
                </label>
              </div>
            );
          })}
      </div>

      <div
        className="task-parts-button my-2 pointer"
        onClick={(e) => {
          onClose();
          onSelectParts(selectedParts); // for add multi part in add butn
        }}
      >
        Add
      </div>
    </div>
  );
};

export default TaskProductsPartsPopup;
